import { useState, useEffect, Fragment } from "react";

import styled from '@emotion/styled';

import NotificationsRoundedIcon from '@mui/icons-material/NotificationsRounded';

import { IconButton, Badge, Tooltip, useTheme, alpha } from "@mui/material";

import { useQuery } from '@tanstack/react-query';

import { BasicFlex } from '../../../utils/Common';

import DrawerDialog from '../../../utils/utilities/DrawerDialog';

const Notifications = () => {
  const theme = useTheme();
 return (
  <Fragment>
   <Tooltip title="Notifications">
    <IconButton color="error" sx={{backgroundColor: alpha(theme.palette.error.main, 0.1)}}>
      <Badge color="error" badgeContent={0}>
        <NotificationsRoundedIcon />
      </Badge>
    </IconButton>
  </Tooltip>
  </Fragment>
 )
};

export default Notifications;